// Traduções das Anomalias da Frota Leve, coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'frotaLeve.anomalias.titulo': 'Anomalia Noturna',
    'frotaLeve.anomalias.eyebrow': 'Operação',
    'frotaLeve.anomalias.regra': 'Ligado na noite',
    'frotaLeve.anomalias.ajuda': 'Veículo da frota leve ligado entre as {{de}} e as {{ate}}, na hora local de onde estava. Conta só o trecho dentro da janela, a partir de {{min}} minutos. A noite é a data do início da janela. Com uma posição a cada 5 minutos, cada ponta tem erro de até 5 minutos.',
    'frotaLeve.anomalias.kpi.ocorrencias': 'Ocorrências',
    'frotaLeve.anomalias.kpi.veiculos': 'Veículos',
    'frotaLeve.anomalias.kpi.horas': 'Horas ligado',
    'frotaLeve.anomalias.kpi.km': 'Km na noite',
    'frotaLeve.anomalias.kpi.semMotorista': 'Sem cartão de motorista: {{n}}',
    'frotaLeve.anomalias.grafico.porNoite': 'Por noite',
    'frotaLeve.anomalias.grafico.porHora': 'Por hora local',
    'frotaLeve.anomalias.grafico.ocorrencias': 'Ocorrências',
    'frotaLeve.anomalias.grafico.minutos': 'Tempo ligado',
    'frotaLeve.anomalias.grafico.noite': 'Noite de {{dia}}: {{n}} ocorrências, {{horas}}, {{km}}',
    'frotaLeve.anomalias.grafico.hora': '{{hora}}: {{horas}} ligado',
    'frotaLeve.anomalias.grafico.vazio': 'Nenhuma ocorrência no período',
    'frotaLeve.anomalias.ranking.veiculos': 'Veículos mais ligados',
    'frotaLeve.anomalias.ranking.motoristas': 'Motoristas mais ligados',
    'frotaLeve.anomalias.ranking.vazio': 'Nada no período',
    'frotaLeve.anomalias.lista': 'Ocorrências',
    'frotaLeve.anomalias.vazio': 'Nenhum veículo ligado na noite neste filtro',
    'frotaLeve.anomalias.filtro.de': 'De',
    'frotaLeve.anomalias.filtro.ate': 'Até',
    'frotaLeve.anomalias.filtro.placa': 'Placa',
    'frotaLeve.anomalias.filtro.classificacao': 'Classificação',
    'frotaLeve.anomalias.filtro.motorista': 'Motorista',
    'frotaLeve.anomalias.filtro.filial': 'Filial',
    'frotaLeve.anomalias.filtro.todas': 'Todas',
    'frotaLeve.anomalias.col.veiculo': 'Veículo',
    'frotaLeve.anomalias.col.motorista': 'Motorista',
    'frotaLeve.anomalias.col.noite': 'Noite',
    'frotaLeve.anomalias.col.horario': 'Horário local',
    'frotaLeve.anomalias.col.ligado': 'Ligado',
    'frotaLeve.anomalias.col.km': 'Km',
    'frotaLeve.anomalias.semMotorista': 'Sem cartão',
    'frotaLeve.anomalias.semClassificacao': 'Sem classificação',
    'frotaLeve.anomalias.noite': '{{de}} a {{ate}}',
    'frotaLeve.anomalias.horario': '{{de}} às {{ate}}',
    'frotaLeve.anomalias.km.odometro': 'Pela diferença do odômetro, em {{pontos}} posições',
    'frotaLeve.anomalias.km.rastro': 'Pelo rastro das posições, {{pontos}} no trecho',
    'frotaLeve.anomalias.km.sem': 'Sem km: as posições não bastaram',
    'frotaLeve.anomalias.fuso.uf': 'Fuso pela UF da posição',
    'frotaLeve.anomalias.fuso.coordenada': 'Fuso pela coordenada da posição',
    'frotaLeve.anomalias.fuso.filial': 'Fuso pela filial do cadastro',
    'frotaLeve.anomalias.fuso.padrao': 'Fuso de Brasília, sem posição nem filial',
    'frotaLeve.anomalias.export.dica': 'Baixa as ocorrências do filtro',
    'frotaLeve.anomalias.export.vazio': 'Nenhuma ocorrência para baixar',
    'frotaLeve.anomalias.vezes': '{{n}}x',
  },
  en: {
    'frotaLeve.anomalias.titulo': 'Night Anomaly',
    'frotaLeve.anomalias.eyebrow': 'Operations',
    'frotaLeve.anomalias.regra': 'On at night',
    'frotaLeve.anomalias.ajuda': 'Light fleet vehicle switched on between {{de}} and {{ate}}, in the local time where it was. Only the stretch inside the window counts, from {{min}} minutes on. The night is the date the window starts. With one position every 5 minutes, each end may be off by up to 5 minutes.',
    'frotaLeve.anomalias.kpi.ocorrencias': 'Occurrences',
    'frotaLeve.anomalias.kpi.veiculos': 'Vehicles',
    'frotaLeve.anomalias.kpi.horas': 'Hours on',
    'frotaLeve.anomalias.kpi.km': 'Km at night',
    'frotaLeve.anomalias.kpi.semMotorista': 'No driver card: {{n}}',
    'frotaLeve.anomalias.grafico.porNoite': 'By night',
    'frotaLeve.anomalias.grafico.porHora': 'By local hour',
    'frotaLeve.anomalias.grafico.ocorrencias': 'Occurrences',
    'frotaLeve.anomalias.grafico.minutos': 'Time on',
    'frotaLeve.anomalias.grafico.noite': 'Night of {{dia}}: {{n}} occurrences, {{horas}}, {{km}}',
    'frotaLeve.anomalias.grafico.hora': '{{hora}}: {{horas}} on',
    'frotaLeve.anomalias.grafico.vazio': 'No occurrences in the period',
    'frotaLeve.anomalias.ranking.veiculos': 'Vehicles most often on',
    'frotaLeve.anomalias.ranking.motoristas': 'Drivers most often on',
    'frotaLeve.anomalias.ranking.vazio': 'Nothing in the period',
    'frotaLeve.anomalias.lista': 'Occurrences',
    'frotaLeve.anomalias.vazio': 'No vehicle on at night for this filter',
    'frotaLeve.anomalias.filtro.de': 'From',
    'frotaLeve.anomalias.filtro.ate': 'To',
    'frotaLeve.anomalias.filtro.placa': 'Plate',
    'frotaLeve.anomalias.filtro.classificacao': 'Classification',
    'frotaLeve.anomalias.filtro.motorista': 'Driver',
    'frotaLeve.anomalias.filtro.filial': 'Branch',
    'frotaLeve.anomalias.filtro.todas': 'All',
    'frotaLeve.anomalias.col.veiculo': 'Vehicle',
    'frotaLeve.anomalias.col.motorista': 'Driver',
    'frotaLeve.anomalias.col.noite': 'Night',
    'frotaLeve.anomalias.col.horario': 'Local time',
    'frotaLeve.anomalias.col.ligado': 'On',
    'frotaLeve.anomalias.col.km': 'Km',
    'frotaLeve.anomalias.semMotorista': 'No card',
    'frotaLeve.anomalias.semClassificacao': 'Unclassified',
    'frotaLeve.anomalias.noite': '{{de}} to {{ate}}',
    'frotaLeve.anomalias.horario': '{{de}} to {{ate}}',
    'frotaLeve.anomalias.km.odometro': 'From the odometer difference, over {{pontos}} positions',
    'frotaLeve.anomalias.km.rastro': 'From the position track, {{pontos}} in the stretch',
    'frotaLeve.anomalias.km.sem': 'No km: not enough positions',
    'frotaLeve.anomalias.fuso.uf': 'Time zone from the position state',
    'frotaLeve.anomalias.fuso.coordenada': 'Time zone from the position coordinates',
    'frotaLeve.anomalias.fuso.filial': 'Time zone from the registered branch',
    'frotaLeve.anomalias.fuso.padrao': 'Brasília time, no position or branch',
    'frotaLeve.anomalias.export.dica': 'Downloads the occurrences in the filter',
    'frotaLeve.anomalias.export.vazio': 'No occurrences to download',
    'frotaLeve.anomalias.vezes': '{{n}}x',
  },
  es: {
    'frotaLeve.anomalias.titulo': 'Anomalía Nocturna',
    'frotaLeve.anomalias.eyebrow': 'Operación',
    'frotaLeve.anomalias.regra': 'Encendido de noche',
    'frotaLeve.anomalias.ajuda': 'Vehículo de la flota liviana encendido entre las {{de}} y las {{ate}}, en la hora local de donde estaba. Cuenta solo el tramo dentro de la ventana, a partir de {{min}} minutos. La noche es la fecha del inicio de la ventana. Con una posición cada 5 minutos, cada extremo tiene un error de hasta 5 minutos.',
    'frotaLeve.anomalias.kpi.ocorrencias': 'Ocurrencias',
    'frotaLeve.anomalias.kpi.veiculos': 'Vehículos',
    'frotaLeve.anomalias.kpi.horas': 'Horas encendido',
    'frotaLeve.anomalias.kpi.km': 'Km de noche',
    'frotaLeve.anomalias.kpi.semMotorista': 'Sin tarjeta de conductor: {{n}}',
    'frotaLeve.anomalias.grafico.porNoite': 'Por noche',
    'frotaLeve.anomalias.grafico.porHora': 'Por hora local',
    'frotaLeve.anomalias.grafico.ocorrencias': 'Ocurrencias',
    'frotaLeve.anomalias.grafico.minutos': 'Tiempo encendido',
    'frotaLeve.anomalias.grafico.noite': 'Noche del {{dia}}: {{n}} ocurrencias, {{horas}}, {{km}}',
    'frotaLeve.anomalias.grafico.hora': '{{hora}}: {{horas}} encendido',
    'frotaLeve.anomalias.grafico.vazio': 'Ninguna ocurrencia en el período',
    'frotaLeve.anomalias.ranking.veiculos': 'Vehículos más encendidos',
    'frotaLeve.anomalias.ranking.motoristas': 'Conductores más encendidos',
    'frotaLeve.anomalias.ranking.vazio': 'Nada en el período',
    'frotaLeve.anomalias.lista': 'Ocurrencias',
    'frotaLeve.anomalias.vazio': 'Ningún vehículo encendido de noche en este filtro',
    'frotaLeve.anomalias.filtro.de': 'Desde',
    'frotaLeve.anomalias.filtro.ate': 'Hasta',
    'frotaLeve.anomalias.filtro.placa': 'Placa',
    'frotaLeve.anomalias.filtro.classificacao': 'Clasificación',
    'frotaLeve.anomalias.filtro.motorista': 'Conductor',
    'frotaLeve.anomalias.filtro.filial': 'Filial',
    'frotaLeve.anomalias.filtro.todas': 'Todas',
    'frotaLeve.anomalias.col.veiculo': 'Vehículo',
    'frotaLeve.anomalias.col.motorista': 'Conductor',
    'frotaLeve.anomalias.col.noite': 'Noche',
    'frotaLeve.anomalias.col.horario': 'Hora local',
    'frotaLeve.anomalias.col.ligado': 'Encendido',
    'frotaLeve.anomalias.col.km': 'Km',
    'frotaLeve.anomalias.semMotorista': 'Sin tarjeta',
    'frotaLeve.anomalias.semClassificacao': 'Sin clasificación',
    'frotaLeve.anomalias.noite': '{{de}} a {{ate}}',
    'frotaLeve.anomalias.horario': '{{de}} a {{ate}}',
    'frotaLeve.anomalias.km.odometro': 'Por la diferencia del odómetro, en {{pontos}} posiciones',
    'frotaLeve.anomalias.km.rastro': 'Por el rastro de las posiciones, {{pontos}} en el tramo',
    'frotaLeve.anomalias.km.sem': 'Sin km: las posiciones no alcanzaron',
    'frotaLeve.anomalias.fuso.uf': 'Huso por el estado de la posición',
    'frotaLeve.anomalias.fuso.coordenada': 'Huso por la coordenada de la posición',
    'frotaLeve.anomalias.fuso.filial': 'Huso por la filial del registro',
    'frotaLeve.anomalias.fuso.padrao': 'Hora de Brasília, sin posición ni filial',
    'frotaLeve.anomalias.export.dica': 'Descarga las ocurrencias del filtro',
    'frotaLeve.anomalias.export.vazio': 'Ninguna ocurrencia para descargar',
    'frotaLeve.anomalias.vezes': '{{n}}x',
  },
}
